import { Component, OnInit, Input, AfterViewInit, inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import * as $ from 'jquery';
import { HoldService, SearchPatron } from '../../../pages/hold/hold.service';
import { SharedService } from '../../../services/shared/shared.service';
import { StorageService } from './../../../services/storage/storage.service';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../sidenav-content';
import { finalize, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AddPatronErrorDialog } from './dialog/add-patron-error.dialog';
import { UserSearchRequest } from '../../../pages/staff/users/user.service';
import { TruncatePipe } from '../../../shared/pipes/truncate/truncate.pipe';
import { DIALOG_STYLE } from '../../../../assets/css/ag/styles';

@Component({
  selector: 'ag-patron-search',
  templateUrl: './patron-search.component.html',
  styleUrls: ['./patron-search.component.scss'],
  providers: [{ provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }],
})
export class PatronSearchComponent
  extends SidenavContent
  implements AfterViewInit, OnInit, OnDestroy
{
  @Input() searchInput: string;
  @Input() agControlId: number;
  @Input() isInSideNav: boolean;
  @Input() canReserve: boolean;

  private _router = inject(Router);
  private _snackBar = inject(MatSnackBar);
  private _holdService = inject(HoldService);
  private _sharedService = inject(SharedService);
  private _storageService = inject(StorageService);
  private _dialog = inject(MatDialog);

  newSelectPatron: any = false;
  patronGroupId: number;
  searchTerm: string;
  searchIndex: number;
  searchPatronResults: any;
  hold: boolean;
  showCurrentPatron: boolean;
  searching: boolean;
  truncatePipe = new TruncatePipe();
  hasPrevious: boolean;
  hasNext: boolean;

  private _offset = 0;
  private _limit = 16;
  private _destroyed$ = new Subject<void>();

  constructor(private _layoutService: LayoutService) {
    super(_layoutService);
  }

  ngOnInit() {
    this._lookUpPatron();
    this.hold = this._router.url.startsWith('/hold');
  }

  ngAfterViewInit() {
    this.showCurrentPatron = this._storageService.isCurrentPatron();
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  currentPatron() {
    this._searchPatron(this._storageService.getPrevPatronValue(), 0).subscribe((response) => {
      this._selectPatron(response.patrons[0]);
    });
  }

  //      ---------------------------------------------------------------------------
  //      ----------------SELECT A PATRON / SHAREit LOOKUP --------------------------
  //      ---------------------------------------------------------------------------
  private _lookUpPatron() {
    this._holdService.getPatronGroupAndIndex().subscribe((data) => {
      this.newSelectPatron = data;
      this.searchIndex = this.newSelectPatron.data.patronIndicesList[0].code;
      this.patronGroupId = this.newSelectPatron.data.patronGroupsList[0].groupID;
      $('#searchPatron').focus();
    });
  }

  getNextPatrons() {
    this._getPatrons(this._offset + this._limit);
  }

  getPrevPatrons() {
    this._getPatrons(this._offset - this._limit);
  }

  private _getPatrons(offset: number) {
    this.searching = true;
    this._offset = offset;
    this._searchPatron(this.searchTerm, this.searchIndex, offset)
      .pipe(finalize(() => (this.searching = false)))
      .subscribe((response) => {
        this._setSearchPatronResults(response);
      });
  }
  private _setSearchPatronResults(response: any) {
    this.searchPatronResults = response;
    this.hasPrevious = this._offset > 0;
    this.hasNext = this.searchPatronResults.matchedPatronCount === this._limit;
  }

  searchPatrons() {
    this._offset = 0;
    this._searchPatron(this.searchTerm, this.searchIndex).subscribe((response) => {
      this._setSearchPatronResults(response);
      if (this.searchPatronResults.patrons.length == 1) {
        this._selectPatron(this.searchPatronResults.patrons[0]);
      }
    });
  }

  private _selectPatron(patron) {
    this.choosePatron(patron);
  }

  private _searchPatron(
    searchTerm: string,
    searchIndex: number,
    offset: number = 0,
  ): Observable<SearchPatron> {
    this.searching = true;
    return this._holdService
      .searchPatrons(this._titleReserveBody(searchTerm, searchIndex, offset), this.agControlId ?? 0)
      .pipe(
        map((response) => response.data),
        finalize(() => (this.searching = false)),
      );
  }

  private _titleReserveBody(
    searchTerm: string,
    searchIndex: number,
    offset: number,
  ): UserSearchRequest {
    return {
      offset: offset,
      limit: this._limit,
      patronGroupId: this.patronGroupId,
      searchTerm: searchTerm,
      searchIndex: searchIndex,
    };
  }

  choosePatron(data) {
    if (data.messages.length > 0) {
      this._dialog.open(AddPatronErrorDialog, {
        panelClass: DIALOG_STYLE.MD,
        data: {
          messages: data.messages,
          name: data.fullName ? data.fullName : data.firstName,
        },
      });
      return;
    }

    this._sharedService.setPatronInfo(data);
    $('#searchPatron').val('');
    this.searchPatronResults = null;
    if (this.isInSideNav) {
      this.closeNav();
    }

    this._snackBar.open('Patron added', null, {
      duration: 4000,
    });
  }
}
